





































import Vue from 'vue'
import PasswordStrength from '@/components/register/PasswordStrength.vue'
import InputField from '@/components/atoms/InputField.vue'
import { MdButton, MdCard, MdField, MdLayout } from 'vue-material/dist/components'
import gql from 'graphql-tag'
import { ApolloError } from '@apollo/client'

Vue.use(MdButton)
Vue.use(MdCard)
Vue.use(MdField)
Vue.use(MdLayout)

export default Vue.extend({
  name: 'RegisterPassword',
  props: ['email'],
  data: () => ({
    password: ''
  }),
  components: {
    PasswordStrength,
    InputField
  },
  methods: {
    register: async function () {
      try {
        let request = await this.$apollo.mutate({
          // Query
          mutation: gql`mutation {
            createIdentity(
              user: {
                email: "${this.email}",
                password: "${this.password}"
                }
            ) {
              token,
              user {
                id
              }
            }
          }`
        })
        if (request.data.createIdentity.token) {
          this.$emit('propagate-value', true, 'registered')
          this.$emit('propagate-value', '', 'error')
        }
      } catch (e) {
        const { graphQLErrors } = e as ApolloError
        let errors = graphQLErrors.map((err) => err.message).join('\n')
        this.$emit('propagate-value', errors, 'error')
      }
    }
  }
})
